export default __webpack_public_path__ + "static/media/icon_email.5c32fc9a.svg";